import { TestPlanResultSession } from './test-plan-result-session.model';

export class TestSuiteResultSession extends TestPlanResultSession {}
